export default __webpack_public_path__ + "static/noun_universe_3984172-462a4aa1af4b7315d953014bd6328a92.svg";